import React from 'react'
import "../css/policies.css"

const Shipping = () => {
    return (
        <div className='policy-p'>
            <h1 style={{ textAlign: "center" }}>Shipping  Policy</h1><br />
            <p>
                <h5><b>No Shipping Policy</b></h5>
                This website is dedicated solely to accepting donations to support our mission. We do not sell, deliver, or ship any physical or digital products.
                As no goods or services are exchanged for donations, a shipping policy is not applicable to our operations.
            </p>
            <p>
                <h5><b>Acknowledgment</b></h5>
            </p>
            By donating through our platform, you acknowledge and agree that no shipping or delivery of products is required or expected as part of your contribution


            <h5><b>Contact Us</b></h5>
            For any questions regarding this policy or our operations, feel free to reach out: <b>Daji Maharaj Devsthan Takli.</b> <br />
            <b>Email: svspgurukul@gmail.com</b>  <br />
            <b>Phone: 9158303000</b>  <br />
            Thank you for your generosity and understanding. Your support is invaluable to us and the communities we serve.
        </div>
    )
}

export default Shipping